import { Controller } from 'react-hook-form';

import { ErrorMessage } from './ErrorMessage';
import { InputLabel } from '../ui/InputLabel';
import MaskedInput from '../ui/MaskedInput';

interface IProps {
  name: string;
  disabled?: boolean;
  suffix?: React.ReactNode;
  label?: string;
}

export const CEPInput = ({ name, disabled, suffix, label = 'CEP' }: IProps) => {
  return (
    <>
      <InputLabel>{label}</InputLabel>
      <Controller
        name={name}
        rules={{ required: true }}
        render={({ field }) => (
          <MaskedInput
            id={name}
            mask='cep'
            placeholder='77700-000'
            message={''}
            suffix={suffix}
            disabled={disabled}
            {...field}
          />
        )}
      />
      <ErrorMessage fieldName={name} />
    </>
  );
};
